export interface IUserEmail {
    address: string;
    verified: boolean;
}
